import React from "react";

const ClosingPrayer = () => {
  return (
    <section className="p-10 md:p-16 text-center bg-green-800 text-white">
      <h2 className="text-3xl md:text-4xl font-bold mb-6">
        Closing Prayer
      </h2>

      <div className="max-w-2xl mx-auto space-y-4 text-lg leading-relaxed">
        <p>
          Heavenly Father, we thank You for Your presence in today’s service.
        </p>

        <p>
          May Your word take root in our hearts and guide us throughout this week.
        </p>

        <p>
          Strengthen us, protect us, and lead us in Your truth and love.
        </p>

        <p className="font-semibold text-yellow-300">
          May the Lord bless you and keep you. Amen.
        </p>
      </div>

      {/* Optional Background Music */}
      <audio controls className="mt-6 mx-auto">
        <source src="/closing-music.mp3" type="audio/mpeg" />
      </audio>
    </section>
  );
};

export default ClosingPrayer;